import Button from 'components/Button';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { loginUrl, signUpUrl } from 'utils/config';
import { btnLogin, btnWrapper, header, heading, logo, name, root } from './HelpCenterHeader.module.scss';


const HelpCenterHeader = ({ logoUrl }) => (
  <div className={root}>
    <header className={header}>
      <nav className={heading}>
        <div>
          <Link to="/" title="首頁" className={logo}>
            <img src={logoUrl} alt="newsleopard 電子豹" />
          </Link>
        </div>
        <div className={name}>
          <Link to={`/help-center`}>Newsleopard 常見問題</Link>
        </div>
      </nav>
      <div className={btnWrapper}>
        <Button
          href={loginUrl}
          size="S"
          type="ghostRegular"
          text="登入"
          className={btnLogin}
        />
        <Button
          href={signUpUrl}
          size="S"
          type="primary"
          text="註冊"
        />
      </div>
  </header>
  </div>
);
HelpCenterHeader.propTypes = {
  logoUrl: PropTypes.string.isRequired,
};

export default HelpCenterHeader;
